'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactLadda = require('react-ladda');

var _reactLadda2 = _interopRequireDefault(_reactLadda);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Modal, _Component);

  function Modal(props) {
    (0, _classCallCheck3.default)(this, Modal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).call(this, props));

    _this.handleCancelClick = function () {
      return _this.props.onCancel();
    };
    _this.handleSaveClick = function () {
      return _this.props.onSave();
    };
    _this.handleCloseClick = function () {
      return _this.props.onClose();
    };
    return _this;
  }

  (0, _createClass3.default)(Modal, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;

      var styles = require('./Modal.scss');
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { onClick: this.handleCancelClick,
          className: styles.mask }),
        _react2.default.createElement(
          'div',
          { className: styles.modal + (this.props.className ? ' ' + this.props.className : '') },
          children,
          typeof this.props.onCancel !== 'undefined' && _react2.default.createElement(
            'button',
            { className: styles.button + ' ' + styles.cancelButton, onClick: this.handleCancelClick },
            'Annuler'
          ),
          typeof this.props.onSave !== 'undefined' && _react2.default.createElement(
            _reactLadda2.default,
            { className: styles.button,
              'data-style': 'slide-down',
              loading: this.props.saving, onClick: this.handleSaveClick },
            'Enregistrer'
          ),
          typeof this.props.onClose !== 'undefined' && _react2.default.createElement(
            'button',
            { className: styles.button + ' ' + styles.cancelButton, onClick: this.handleCloseClick },
            'Fermer'
          )
        )
      );
    }
  }]);
  return Modal;
}(_react.Component), _class.propTypes = {
  onCancel: _react.PropTypes.func,
  onSave: _react.PropTypes.func,
  onClose: _react.PropTypes.func,
  children: _react.PropTypes.object.isRequired,
  saving: _react.PropTypes.bool,
  className: _react.PropTypes.string
}, _temp);
exports.default = Modal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.js
// module id = 1164
// module chunks = 0